import I18N from '../data/i18n-translations';

export let currentLang = localStorage.getItem('lp_aiboard_lang') || 'en';

export function getCurrentLang() {
  return currentLang;
}

/* Look up a translation. Returns the localized string if present in either
 * the current language or the English fallback. Returns the key itself only
 * if no translation exists at all — callers that prefer keeping the HTML's
 * own literal text should use `tOrNull` instead. */
export function t(key, vars = undefined) {
  const found = (I18N[currentLang] && I18N[currentLang][key]) || I18N.en[key];
  let s = found != null ? found : key;
  if (vars) Object.keys(vars).forEach((k) => { s = s.replace(`{${k}}`, vars[k]); });
  return s;
}

/* Returns the translation if it exists in either current-language or
 * English. Returns null if not found in any table — DOES NOT fall back to
 * the key. Used by applyLang() so missing keys leave the HTML fallback
 * text in place instead of clobbering it with `auth.login.title` literals. */
export function tOrNull(key, vars = undefined): string | null {
  const found = (I18N[currentLang] && I18N[currentLang][key]) || I18N.en[key];
  if (found == null) return null;
  let s = found;
  if (vars) Object.keys(vars).forEach((k) => { s = s.replace(`{${k}}`, vars[k]); });
  return s;
}

export function applyLang() {
  document.documentElement.lang = currentLang;

  document.querySelectorAll('[data-i18n]').forEach((el) => {
    const key = el.dataset.i18n;
    if (!key) return;
    const value = tOrNull(key);
    // Leave existing textContent in place when the key isn't translated —
    // the HTML literal IS the English fallback. Clobbering with the raw key
    // (e.g. "auth.signin") is the bug we used to ship.
    if (value !== null) el.textContent = value;
  });

  document.querySelectorAll('[data-i18n-placeholder]').forEach((el) => {
    const key = el.dataset.i18nPlaceholder;
    if (!key) return;
    const value = tOrNull(key);
    if (value !== null) el.placeholder = value;
  });

  document.querySelectorAll('.lang-switcher button').forEach((b) => {
    b.classList.toggle('active', b.dataset.lang === currentLang);
  });

  window.dispatchEvent(new CustomEvent('lp-lang-changed'));
}

/* =================================================================
   Lang switcher
   ================================================================= */
export function attachLangSwitcher() {
  document.querySelectorAll('.lang-switcher button').forEach((b) => {
    b.addEventListener('click', () => {
      currentLang = b.dataset.lang;
      localStorage.setItem('lp_aiboard_lang', currentLang);
      applyLang();
    });
  });
}
